import TableDefinitions from '../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.MRD.isLoading;
export const getData = TableDefinitions.MRD.getDataFunction();

export const getIsLoadingInactive = (state) => state.listing.MRD_INACTIVE.isLoading;
export const getDataInactive = TableDefinitions.MRD_INACTIVE.getDataFunction();

export const getMrdStatuses = (state) => state.mrd.statuses;
export const getMrdTypes = (state) => state.mrd.types;
export const getPostalOperators = (state) => state.mrd.operators;

export const getEditMrdSuccessStatus = (state) => state.mrd.editMrdSuccess;
export const getAddMrdSuccessStatus = (state) => state.mrd.addMrdSuccess;
export const getPersistFormData = (state) => state.mrd.persistFormData;
export const getAssociateHandlerSuccessStatus = (state) => state.mrd.associateHandlerSuccess;

export const getHandlerListByImpc = (state) => state.listing.HANDLERS_BY_IMPC.data;
export const getIsHandlerListByImpcLoading = (state) => state.listing.HANDLERS_BY_IMPC.isLoading;
export const getAssociateHandlerFormCheckboxSelections = (state) => state.listing.HANDLERS_BY_IMPC.checkboxSelections;
export const getActiveMrdList = (state) => state.mrd.activeMrdList;
export const getInboundDataLocationsList = (state) => state.mrd.inboundDataLocationList;
